import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import { AnimatedSection } from 'remote-com-shared/style/motion';
import styled from 'styled-components';

import {
  OverviewLabel,
  OverviewSectionHeader,
  OverviewTitleComponent,
  OverviewDescriptionComponent,
} from '@/src/components/OverviewSection';
import {
  OverviewSectionSingleRow,
  ImageWrapper,
} from '@/src/components/OverviewSection/OverviewSectionRow';
import { components } from '@/src/views/InternationalGlobalPayroll/slices//GlobalPayrollSlice';

const Wrapper = styled.section`
  background-color: var(--colors-blank);

  ${OverviewTitleComponent} {
    max-width: unset;
  }

  ${OverviewDescriptionComponent} {
    color: var(--colors-bayoux);
  }
`;

const OverviewSectionWrapper = styled.div`
  ${fluidProp('padding-bottom', '5px', '120px')}
  ${fluidProp('padding-top', '10px', '50px')}

  ${ImageWrapper} {
    margin-bottom: 0;
  }
`;

export function OverviewSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { howDoesItWorkLabel, howDoesItWorkTitle, howDoesItWorkDescription, bgColor } = primary;
  const { fields: overviewSections } = slice;

  const hasHeading =
    fieldHasContent(howDoesItWorkLabel) ||
    fieldHasContent(howDoesItWorkTitle) ||
    fieldHasContent(howDoesItWorkDescription);

  return (
    <Wrapper>
      <AnimatedSection ComponentName={OverviewSectionHeader}>
        {hasHeading && (
          <ContentContainer>
            {fieldHasContent(howDoesItWorkLabel) && (
              <OverviewLabel>
                <small>{howDoesItWorkLabel}</small>
              </OverviewLabel>
            )}
            {fieldHasContent(howDoesItWorkTitle) && (
              <OverviewTitleComponent>
                <PrismicRichText field={howDoesItWorkTitle} />
              </OverviewTitleComponent>
            )}
            {fieldHasContent(howDoesItWorkDescription) && (
              <OverviewDescriptionComponent>
                <PrismicRichText field={howDoesItWorkDescription} components={components} />
              </OverviewDescriptionComponent>
            )}
          </ContentContainer>
        )}
      </AnimatedSection>

      {overviewSections.map(
        (
          {
            label,
            title,
            description: content,
            illustration,
            illustration_on_the_edge: onEdge,
            icon,
            note,
          },
          index
        ) => (
          <OverviewSectionWrapper key={index}>
            <OverviewSectionSingleRow
              label={label}
              title={title}
              description={content}
              illustration={illustration}
              illustration_on_the_edge={onEdge}
              directionOffset={index % 2}
              icon={icon}
              note={note}
              bgColor={bgColor}
            />
          </OverviewSectionWrapper>
        )
      )}
    </Wrapper>
  );
}
